import { render } from "./HomeView.vue?vue&type=template&id=6c3dee51&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhifangxu/Documents/workspace.nosync/9teacher/code/3staudent_cli/3student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__